module.exports = __webpack_public_path__ + "static/media/photoshop.c047f5d2.jpg";